import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/scanner/error.tsx");
